import axios from "axios";

export let API_URL = "";
export let GOOGLE_CLIENT_ID = "";

export const SetApiUrl = (url) => {
  API_URL = url;
};

export const SetGoogleClientId = (client_id) => {
  GOOGLE_CLIENT_ID = client_id;
};

export const FetchConfig = async (path) => {
    let response = await axios(path);
    if (response.status) {
        return response.data
    }
    throw new Error('No config')
};
  
  